/** @file previousFill: what a slot holds before a fill, as a fill item (image and fit, or null). */
import type { PuppetDoc } from '../puppetDoc/puppetDoc';
import type { SlotFillItem } from '../types/puppetInputs';

/** `{ slot, image: prev, fit? }` with the stored fit of `prev`, or `{ slot, image: null }` for an empty slot. */
export function previousFill(draft: PuppetDoc, slot: string, prev: string | undefined): SlotFillItem {
  if (prev === undefined) return { slot, image: null };
  const fit = draft.images[prev]?.fit?.mode;
  return fit === undefined ? { slot, image: prev } : { slot, image: prev, fit };
}
